import React from 'react';
import {Button} from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ParticipantList = ({ participants, onRemoveParticipant, isLoading }) => {
  if (participants?.length === 0) {
    return (
      <div className="bg-card rounded-lg border border-border p-6 shadow-subtle">
        <div className="text-center py-8">
          <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="Users" size={24} className="text-muted-foreground" />
          </div>
          <h3 className="text-lg font-medium text-foreground mb-2">No participants added yet</h3>
          <p className="text-sm text-muted-foreground">
            Add participants to start sharing expenses with your group
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-subtle">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-foreground mb-1">
          Participants ({participants?.length})
        </h3>
        <p className="text-sm text-muted-foreground">
          People who will be part of this expense sharing group
        </p>
      </div>
      <div className="space-y-3">
        {participants?.map((participant) => (
          <div
            key={participant?.id}
            className="flex items-center justify-between p-3 bg-muted/50 rounded-lg border border-border/50"
          >
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
                {participant?.avatar ? (
                  <img 
                    src={participant?.avatar} 
                    alt={participant?.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                ) : (
                  <span className="text-sm font-medium text-primary-foreground">
                    {participant?.name?.charAt(0)?.toUpperCase()}
                  </span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground truncate">
                  {participant?.name}
                </p>
                <p className="text-xs text-muted-foreground truncate">
                  {participant?.email}
                </p>
              </div>
            </div>
            
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onRemoveParticipant(participant?.id || participant?.email)}
              disabled={isLoading}
              iconName="X"
              className="text-muted-foreground hover:text-destructive hover:bg-destructive/10"
              aria-label={`Remove ${participant?.name}`}
            />
          </div>
        ))}
      </div>
      <div className="mt-4 p-3 bg-accent/10 rounded-lg border border-accent/20">
        <div className="flex items-start space-x-2">
          <Icon name="Info" size={16} className="text-accent mt-0.5 flex-shrink-0" />
          <div>
            <p className="text-sm text-foreground font-medium">Ready to create</p>
            <p className="text-xs text-muted-foreground mt-1">
              You can add more participants after creating the event
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParticipantList;
